module.exports = __webpack_public_path__ + "static/media/shell-select.9f739f55.png";